import stripe from "./factories/StripePaymentGateway";
host.plugins.register({
    // #region Vars
    name: "288a.payment.stripe",
    // #endregion
    // #region Constructor
    register() {
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
        host.provider.register('PAYMENT', 'stripe', new stripe());
    },
    // #endregion
});
